// Simple protein summary caching service
class ProteinService {
  constructor() {
    this.cache = new Map();
    this.cacheTimeout = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
  }

  // Cache protein summary with timestamp
  cacheProteinSummary(proteinName, summary) {
    if (proteinName && summary) {
      this.cache.set(proteinName, {
        summary,
        timestamp: Date.now()
      });
    }
  }

  // Get cached protein summary if still valid
  getCachedProteinSummary(proteinName) {
    const cached = this.cache.get(proteinName);
    if (!cached) return null;

    // Check if cache is still valid (24 hours)
    if (Date.now() - cached.timestamp > this.cacheTimeout) {
      this.cache.delete(proteinName);
      return null;
    }

    return cached.summary;
  }

  // Process API response and cache protein summaries
  processLLMOutputData(data) {
    // Cache protein summary from API response
    if (data.protein_name && data.protein_summary) {
      this.cacheProteinSummary(data.protein_name, data.protein_summary);
    }
    return data;
  }

  // Process array of LLM outputs and cache all protein summaries
  processLLMOutputArray(dataArray) {
    if (Array.isArray(dataArray)) {
      dataArray.forEach(data => {
        if (data.protein_name && data.protein_summary) {
          this.cacheProteinSummary(data.protein_name, data.protein_summary);
        }
      });
    }
    return dataArray;
  }

  // Clear cache (useful for development or memory management)
  clearCache() {
    this.cache.clear();
  }

  // Get all cached protein names
  getCachedProteinNames() {
    return Array.from(this.cache.keys());
  }

  // Get cache statistics
  getCacheStats() {
    return {
      size: this.cache.size,
      proteins: this.getCachedProteinNames()
    };
  }
}

// Create and export singleton instance
const proteinService = new ProteinService();
export default proteinService;